module.exports = __webpack_public_path__ + "assets/img/Ober_004.33a77b14.jpg";